import { createFileRoute } from '@tanstack/react-router'
import { AgentModelsPage } from '../../../modules/agent-workspace'

export const Route = createFileRoute('/_authed/agent-workspace/models')({
  component: AgentModelsPage,
})
